import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false,
})
export class CardComponent {
  @Input() backgroundColor?: string;
  @Input() hasRippleEffect?: boolean = true;
  @Input() selected = false;
}
